<template>
  <Card title="Aison" :error="adapterError" errorTitle="Failed to Connect">
    <template #header-suffix>
      <ConnectionIndicator :connected="adapterConnected" />
    </template>
    <AisonForm
      v-model="aison"
      :enabled="!adapterLoading && !adapterConnected"
      :connected="adapterConnected"
    />
    <template v-slot:footer>
      <Button
        v-if="!adapterConnected"
        :loading="adapterLoading"
        @click="connect"
        variant="success"
      >
        Connect
      </Button>
      <Button v-if="adapterConnected" @click="change" :loading="adapterLoading">
        Change
      </Button>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';

import store from '@/plugins/vuex';
import Button from '@/components/Button.vue';
import Card from '@/components/Card.vue';
import AisonForm from '@/components/adapters/AisonForm.vue';
import ConnectionIndicator from '@/components/ConnectionIndicator.vue';

export default defineComponent({
  name: 'Target',
  components: {
    AisonForm,
    Card,
    Button,
    ConnectionIndicator,
  },
  data() {
    return {
      aison: store.getters.target.connectRequest.adapter,
    };
  },
  computed: {
    ...mapState({
      adapterConnected: (state: any) => state.target.adapterConnected,
      adapterLoading: (state: any) => state.target.adapterLoading,
      adapterError: (state: any) => state.target.adapterError,
    }),
    ...mapGetters({
      targetConnectRequest: 'target/connectRequest',
    }),
  },
  methods: {
    connect() {
      store.dispatch.target.updateAdapter({ adapter: this.aison });
      store.dispatch.target.connectAdapter(null);
    },
    change() {
      store.dispatch.target.updateAdapter({ adapter: this.aison });
    },
  },
  watch: {
    targetConnectRequest(val) {
      this.aison = val?.adapter;
    },
  },
});
</script>
